export default __webpack_public_path__ + "static/media/whoweare.5df3c0d1.jpg";